/**
 * @owner @Appboy/billing
 */

// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isCreditRatiosResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      channel_grouping: string,
      destination: string,
      credit_ratio: number,
    })
  ),
});
